'use strict';

import modalController from '../modal/reasignarusuario.controller';
import modalTemplate from '../modal/reasignarusuario.html';

class ProyectoController {
  constructor($state, $stateParams, DataService, Modal,$log) {
    'ngInject';

    this.$state = $state;
    this.$stateParams = $stateParams;
    this.DataService = DataService;
    this.Modal = Modal;
    this.$log=$log;
  }

  $onInit() {
    this.$$cargarDatos();
  }

  $$cargarDatos() {
    this.DataService.get(`adminproyectos/${this.$stateParams.codigo}/usuarios`).then((resp)=>{
      if (resp && resp.finalizado) {
        this.proyecto = resp.datos;
        this.dtsRol = JSON.parse(localStorage.getItem("upre_rol"));        
        this.$log.log('ROLES2=======>',this.dtsRol['nombre'] )

        this.$log.log('p1===>' + JSON.stringify(this.proyecto));
        this.$log.log('p2===>' + JSON.stringify(this.proyecto.usuario_rol.nombre));
      }
    });
  }

  reasignarUsuario(transicion) {
    const REENVIO = this.Modal.show({
      template: modalTemplate,
      controller: modalController,
      data: {
        transicion
      }
    });
    REENVIO.result.then((result) => {
      if (result) {
        this.$state.reload();
      }
    }).catch(() => {});
  }

  reasignarUsuarioProy(proyecto) {
    let transicion = {
      objeto: proyecto.id_proyecto,
      tipo: 'proyecto',
      usuario_asignado: proyecto.usuario,
      usuario_asignado_rol: proyecto.usuario_rol,
    }
    const REENVIO = this.Modal.show({
      template: modalTemplate,
      controller: modalController,
      data: {
        transicion
      }
    });
    REENVIO.result.then((result) => {
      if (result) {
        this.$state.reload();
      }
    }).catch(() => {});
  }

}

export default ProyectoController;



// WEBPACK FOOTER //
// ./src/app/components/admin/proyectos/proyecto/datos.controller.js